import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';
const TimePickerField = _ref => {
  let enabled = _ref.enabled,
    onChange = _ref.onChange,
    path = _ref.path,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$pickerType = _ref.pickerType,
    pickerType = _ref$pickerType === void 0 ? '12hr' : _ref$pickerType;
  const handleChange = val => {
    if (val !== value) {
      const d = new Date(val);
      return onChange({
        path,
        displayValue: d.toTimeString(),
        value: val
      });
    }
    return undefined;
  };

  /**
   * Handle when picker opens with no value - set default to current time on today's date
   */
  const handleOpen = () => {
    if (value === null || value === undefined) {
      // Get current time and represent it as a UTC ISO string
      const now = new Date();
      const defaultValue = now.toISOString();
      handleChange(defaultValue);
    }
  };
  const id = "tpf-".concat(kebabCase(label));
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": id
  }, /*#__PURE__*/React.createElement(Label, {
    value: label
  }), /*#__PURE__*/React.createElement(DateTimePicker, {
    viewMode: "time",
    className: "tqc-time-picker-field",
    onChange: handleChange,
    value: value,
    onOpen: handleOpen,
    dateFormat: null,
    timeFormat: pickerType === '24hr' ? 'HH:mm' : 'h:mm A',
    disabled: !enabled,
    verticalPadding: false
  }));
};
TimePickerField.propTypes = {
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  pickerType: PropTypes.string,
  value: PropTypes.string
};
export { TimePickerField as UncomposedTimePickerField };
export default entityComposition(TimePickerField, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});